<template>
  <div class="filter-wrapper">
    <app-button
      ref="button"
      type="secundary"
      :aria-expanded="show ? 'true' : 'false'"
      data-qa="quote-status-filter-button"
      @click="toggleFilter"
    >
      <icon icon="filter" />
      {{ i18n.t('/dashboard/quotestatusfilter') }}
    </app-button>
    <div ref="filter">
      <slide-in-animation v-if="show">
        <div class="filter">
          <form action="">
            <legend class="sr-only">Quote status filter</legend>
            <div class="fields">
              <app-fieldset title="Quote status" class="fieldset">
                <form-radio-button id="quotefilter-0" title="Alle">
                  <input
                    id="quotefilter-0"
                    v-model="quoteStatus"
                    type="radio"
                    value=""
                    name="quotefilter-status"
                    @change="updateFilter"
                  />
                </form-radio-button>
                <form-radio-button id="quotefilter-1" :title="getStatus('CONCEPT')">
                  <input
                    id="quotefilter-1"
                    v-model="quoteStatus"
                    type="radio"
                    value="CONCEPT"
                    name="quotefilter-status"
                    @change="updateFilter"
                  />
                </form-radio-button>
                <form-radio-button id="quotefilter-2" :title="getStatus('QUOTE')">
                  <input
                    id="quotefilter-2"
                    v-model="quoteStatus"
                    type="radio"
                    value="QUOTE"
                    name="quotefilter-status"
                    @change="updateFilter"
                  />
                </form-radio-button>

                <form-radio-button
                  v-if="dealerSettings.salesApprovalEnabled"
                  id="quotefilter-3"
                  :title="getStatus('TO_APPROVE')"
                >
                  <input
                    id="quotefilter-3"
                    v-model="quoteStatus"
                    type="radio"
                    value="TO_APPROVE"
                    name="quotefilter-status"
                    @change="updateFilter"
                  />
                </form-radio-button>

                <form-radio-button
                  v-if="dealerSettings.salesApprovalEnabled"
                  id="quotefilter-4"
                  :title="getStatus('APPROVED')"
                >
                  <input
                    id="quotefilter-4"
                    v-model="quoteStatus"
                    type="radio"
                    value="APPROVED"
                    name="quotefilter-status"
                    @change="updateFilter"
                  />
                </form-radio-button>

                <form-radio-button
                  v-if="dealerSettings.salesApprovalEnabled"
                  id="quotefilter-5"
                  :title="getStatus('REJECTED')"
                >
                  <input
                    id="quotefilter-5"
                    v-model="quoteStatus"
                    type="radio"
                    value="REJECTED"
                    name="quotefilter-status"
                    @change="updateFilter"
                  />
                </form-radio-button>

                <form-radio-button
                  v-if="dealerSettings.salesApprovalEnabled"
                  id="quotefilter-6"
                  :title="getStatus('CONFIRMED')"
                >
                  <input
                    id="quotefilter-6"
                    v-model="quoteStatus"
                    type="radio"
                    value="CONFIRMED"
                    name="quotefilter-status"
                    @change="updateFilter"
                  />
                </form-radio-button>

                <form-radio-button id="quotefilter-7" title="Salesorder">
                  <input
                    id="quotefilter-7"
                    v-model="quoteStatus"
                    type="radio"
                    value="SALESORDER"
                    name="quotefilter-status"
                    @change="updateFilter"
                  />
                </form-radio-button>
              </app-fieldset>
            </div>
          </form>
        </div>
      </slide-in-animation>
    </div>
  </div>
</template>

<script>
import FormRadioButton from '@/components/generic/presentational/atoms/formRadioButton/FormRadioButton.vue'
import AppFieldset from '@/components/generic/presentational/atoms/appFieldset/AppFieldset.vue'
import SlideInAnimation from '@/components/generic/animations/SlideIn.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import { ref } from 'vue'
import { getStatus } from '@/helpers/statusHelper'
import { mapGetters } from 'vuex'

export default {
  components: {
    FormRadioButton,
    AppFieldset,
    SlideInAnimation,
    AppButton,
    Icon,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: ['onUpdateStatusFilter'],
  setup() {
    const filter = ref(null)

    return {
      filter,
    }
  },
  data() {
    return {
      show: false,
      quoteStatus: this.modelValue,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      dealerSettings: 'user/dealerSettings',
    }),
  },
  beforeUnmount() {
    this.removeEventListeners()
  },
  methods: {
    toggleFilter(event) {
      event.stopPropagation()
      if (this.show) {
        this.hideFilter()
      } else {
        this.showFilter()
      }
    },
    showFilter() {
      this.show = true
      this.$nextTick(() => {
        this.addEventListeners()
      })
    },
    hideFilter() {
      this.show = false
      this.removeEventListeners()
    },
    addEventListeners() {
      document.addEventListener('keydown', this.closeByEscapeKey)
      document.addEventListener('click', this.closeByClickingOutsideFilter)
    },
    removeEventListeners() {
      document.removeEventListener('keydown', this.closeByEscapeKey)
      document.removeEventListener('click', this.closeByClickingOutsideFilter)
    },
    closeByEscapeKey(event) {
      if (event.keyCode !== 27) return
      this.hideFilter()
    },
    closeByClickingOutsideFilter(event) {
      if (this.filter.contains(event.target)) return
      this.hideFilter()
    },
    updateFilter() {
      this.$emit('onUpdateStatusFilter', this.quoteStatus)
    },
    getStatus(name) {
      return getStatus(name)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  position: relative;
}

.filter {
  position: absolute;
  background: $white;
  top: 100%;
  left: 0;
  border: 1px solid $gray;
  padding: 0.25em;
  margin-top: 0.5em;
  z-index: 9;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 1em;
    top: -0.5em;
    border-left: 0.5em solid transparent;
    border-right: 0.5em solid transparent;
    border-bottom: 0.5em solid;
  }

  &::before {
    border-bottom-color: $gray;
  }
  &::after {
    margin-top: 1px;
    border-bottom-color: $white;
  }
}

.fieldset :deep() {
  .radio-button {
    margin-top: 0;
  }

  .fields {
    grid-gap: 0.25em;
    margin-bottom: 0;
  }
}

.icon {
  @include icon();

  fill: currentColor;
}
</style>
